// Delivery Terms, Distance Charges, and Night Policy Utility for Velpula Mess

export const STORE_LOCATION = { lat: 17.4927058, lng: 78.6639096 }; // Velpula Meals Veg & Non Veg, Karimguda
export const STORE_ADDRESS = "Beside ORR TSSIC Industrial Area, Velpulavanam Venture, Karimguda, Telangana 501302";
export const STORE_PHONE = "+91 98487 70865";
export const STORE_PLUS_CODE = "FMV7+3H Karimguda, Telangana";
export const STORE_MAPS_URL = "https://maps.google.com/?q=17.4927058,78.6639096";

export const MAX_DELIVERY_DISTANCE_KM = 8.0;
export const FREE_DELIVERY_THRESHOLD = 499;

/**
 * Check if the current time falls under the Late Night session (10:00 PM to 6:00 AM)
 * Indian Standard Time (IST)
 */
export function isNightSession(date = new Date()) {
  const hours = Number(new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", hour: "2-digit", hourCycle: "h23" }).format(date));
  return hours >= 22 || hours < 6;
}

/**
 * Calculate distance in km between two GPS coordinates using the Haversine formula
 */
export function calculateDistanceKm(lat1, lon1, lat2, lon2) {
  if (!lat1 || !lon1 || !lat2 || !lon2) return 0;
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return Math.round(R * c * 10) / 10;
}

/**
 * Calculate Delivery Fee based on distance and order subtotal:
 * - 0 to 2 km: ₹20 (Base fee)
 * - Beyond 2 km: +₹10 per km up to 8 km
 * - Orders above ₹499: ₹0 (FREE DELIVERY)
 */
export function calculateDeliveryFee(distanceKm, subtotal = 0) {
  if (subtotal >= FREE_DELIVERY_THRESHOLD) {
    return { fee: 0, isFree: true, reason: `Free Delivery unlocked for orders above ₹${FREE_DELIVERY_THRESHOLD}!` };
  }

  const d = Number(distanceKm) || 0;
  if (d <= 0) {
    return { fee: 20, isFree: false, reason: "Base delivery charge (0-2 km)" };
  }
  if (d <= 2.0) {
    return { fee: 20, isFree: false, reason: "0 - 2 km delivery tier (₹20)" };
  }
  if (d <= 8.0) {
    const fee = 20 + Math.ceil(d - 2) * 10;
    return { fee, isFree: false, reason: `${Math.floor(d)} - ${Math.ceil(d)} km delivery tier (₹${fee})` };
  }

  return { fee: 80, isFree: false, isOutOfBounds: true, reason: "Location is outside our 8.0 km delivery radius" };
}

export const DELIVERY_TERMS = [
  { label: "0 - 2 km", charge: "₹20" },
  { label: "2 - 4 km", charge: "₹30 - ₹40" },
  { label: "4 - 8 km", charge: "₹50 - ₹80" },
  { label: "Above ₹499", charge: "FREE DELIVERY 🎉", highlight: true },
];

export const DELIVERY_AREAS = [
  "Karimguda & ORR TSSIC",
  "Rampally & Rampally X Roads",
  "Keesara & Keesaragutta Road",
  "Nagaram & Dammaiguda",
  "Ghatkesar & Outer Ring Road",
  "Infosys Tech Park & Mindspace Pocharam",
  "Sreenidhi College (SNIST) & Student Hostels",
  "Cherlapally Railway Station & Industrial Area"
];
